import { useTranslation } from '@shared/translation';
import type { Column } from '@tanstack/react-table';
import { useMemo } from 'react';
import { useOptions } from './useOptions';

// Translate value(s) of table cell using columns options specified in
// `columnDef.meta.options()`.
export const useTranslateValue = (
  value: unknown,
  column: Column<any, any> | undefined
) => {
  const options = useOptions(column);
  const { translate } = useTranslation();

  return useMemo(() => {
    if (options === undefined) {
      return value;
    }
    const lookup = (v: unknown) =>
      translate(options.find((option) => option.value === v)?.label) ?? v;

    return Array.isArray(value) ? value.map(lookup) : lookup(value);
  }, [options, value, translate]);
};
